import { combineReducers } from 'redux';
import accountReducer from './account.reducer';
import tenantReducer from './tenant.reducer';
import configureReducer from './configure.reducer';
import mobileConfigReducer from './mobileConfig.reducer';
import mpReducer from './mp.reducer';
import dashboardReducer from './dashboard.reducer';
import reportReducer from './report.reducer';
import generalReducer from './general.reducer';
import phrasesReducer from './phrases.reducer';
import permissionsReducer from './permissions.reducer';
import sensorsReducer from './sensors.reducer';
import mapsReducer from './maps.reducer';
import ackAlarmsReducer from './ackAlarms.reducer';
import unitsReducer from './units.reducer';
import batchReducer from './batch.reducer';
import lookupReducer from './lookup.reducer';
import department from './department.reducer';

const allReducers = combineReducers({
  account: accountReducer,
  tenant: tenantReducer,
  configure: configureReducer,
  mobileConfig: mobileConfigReducer,
  dashboard: dashboardReducer,
  mp: mpReducer,
  report: reportReducer,
  general: generalReducer,
  phrases: phrasesReducer,
  permissions: permissionsReducer,
  sensors: sensorsReducer,
  maps: mapsReducer,
  ackAlarms: ackAlarmsReducer,
  units: unitsReducer,
  batch: batchReducer,
  lookup: lookupReducer,
  department,
});

export default allReducers;
